export const CYCLE_STUDENT_STATUS = {
  STARTED: 'Started',
  NOT_STARTED: 'NotStarted',
  FINISHED: 'Finished',
  SUBMITTED: 'Submitted',
  RETURNED: 'Returned'
};
